import { render, staticRenderFns } from "./config-toolbar.vue?vue&type=template&id=6b9dda5d&scoped=true&"
import script from "./config-toolbar.vue?vue&type=script&lang=js&"
export * from "./config-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./config-toolbar.vue?vue&type=style&index=0&id=6b9dda5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9dda5d",
  null
  
)

export default component.exports